import type { ReactNode, JSX} from "react";
import { cn, pxClass, pyClass, pClass } from "./cn";

export interface ScrollableProps {
  /** Uniform padding */
  readonly p?: number;
  /** Horizontal padding */
  readonly px?: number;
  /** Vertical padding */
  readonly py?: number;
  /** Extra className (positioning, margins only) */
  readonly className?: string;
  readonly children: ReactNode;
}

/**
 * A flex-1 scrollable container. Place inside a full-height flex column.
 */
export function Scrollable({ p, px, py, className, children }: ScrollableProps): JSX.Element {
  return (
    <div className={cn("flex-1 overflow-y-auto", pClass(p), pxClass(px), pyClass(py), className)}>
      {children}
    </div>
  );
}
